import { registerPlugin } from '@capacitor/core';
import { isNativeApp } from './platform';

const TruecallerNative = registerPlugin('Truecaller');

export const warmupTruecaller = async () => {
  if (!isNativeApp()) return false;
  try {
    const res = await TruecallerNative.warmup();
    return Boolean(res?.ready);
  } catch {
    return false;
  }
};

export const startTruecallerLogin = async () => {
  if (!isNativeApp()) {
    throw new Error('native-only');
  }
  await TruecallerNative.startLogin();
};

export const isTruecallerAvailable = async () => {
  if (!isNativeApp()) return { available: false, reason: 'web' };
  try {
    const res = await TruecallerNative.isAvailable();
    return {
      available: Boolean(res?.available),
      reason: res?.reason || (res?.available ? 'ok' : 'unavailable'),
    };
  } catch (e) {
    return { available: false, reason: e?.message || 'plugin-error' };
  }
};
